
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27.2","height":"27.2","viewBox":"0 0 27.2 27.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.2 13.3c-.1 7.4-6.1 13.3-13.5 13.3-2.2 0-4.4-.6-6.3-1.7L0 27.2l2.4-7.1C1.1 18 .5 15.7.5 13.2.6 5.9 6.6 0 14 .1 21.3.1 27.2 6 27.2 13.3zM13.9 2.1c-6.2 0-11.2 5-11.2 11.2 0 2.4.7 4.6 2.1 6.5L3.4 24l4.3-1.4c5.2 3.4 12.2 2 15.6-3.2 1.2-1.8 1.8-3.9 1.8-6.1 0-6.2-5-11.2-11.2-11.2zm6.7 14.2c-.1-.1-.3-.2-.6-.4s-1.9-.9-2.2-1.1-.5-.2-.7.2-.8 1.1-1 1.3-.4.2-.7.1c-1-.4-1.9-.9-2.6-1.6-.7-.7-1.3-1.4-1.8-2.3-.2-.3 0-.5.1-.7.1-.1.3-.4.5-.6.1-.2.2-.3.3-.5.1-.2.1-.4 0-.6-.1-.2-.7-1.8-1-2.4s-.7-.5-.9-.5h-.6c-.4 0-.7.2-.9.4-.7.7-1.2 1.7-1.1 2.7.1 1.2.6 2.4 1.3 3.4.2.2 2.3 3.6 5.6 4.9s3.3.9 3.9.8c.9-.2 1.7-.7 2.2-1.5.2-.5.3-1 .2-1.6z"}})])
          )
        }
      }
    